/**
 * Меню браузера по правой кнопке — выключено везде, кроме разрешённых мест.
 *
 * Нужно потому, что правая кнопка в этом приложении занята: по ней
 * открывается наше меню — на человеке в звонке, на трансляции. Браузерное
 * поверх него не нужно, а в desktop-сборке оно и вовсе неуместно: «назад»,
 * «обновить» и «посмотреть код» относятся к странице, которой человек тут не
 * видит.
 *
 * Ставится один раз на документ, а не по месту: иначе каждая новая часть
 * интерфейса начинается с того, что кто-то забыл про правую кнопку, и меню
 * вылезает то в ленте, то на плашке.
 */

/**
 * Где браузерное меню остаётся.
 *
 * Поля ввода — потому что вставка мышью живёт только там: своего меню с
 * «вырезать / копировать / вставить» у нас нет, и запретить чужое значило бы
 * отнять вставку у тех, кто не знает про Ctrl+V.
 *
 * `data-menu="native"` — способ разрешить его где-то ещё, не трогая этот
 * файл. Правило одно и лежит в одном месте, поэтому спорить с ним по месту
 * не приходится.
 */
const ALLOWED = 'input, textarea, [contenteditable=""], [contenteditable="true"], [data-menu="native"]';

export function holdContextMenu(): () => void {
  const onMenu = (event: MouseEvent) => {
    const target = event.target as Element | null;

    // `closest` есть не у всякой цели: событие может прийти и от текстового
    // узла, и от документа.
    if (target?.closest?.(ALLOWED)) return;

    event.preventDefault();
  };

  document.addEventListener("contextmenu", onMenu);
  return () => document.removeEventListener("contextmenu", onMenu);
}
